import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { setupGlobalErrorHandler } from "./lib/errorHandler";

// SECURITY: Setup global error handler
setupGlobalErrorHandler();

const rootElement = document.getElementById("root")!;
const anyRoot = rootElement as any;

// ✅ Previne double-mount no Lovable (HMR)
if (!anyRoot.__hasRoot) {
  const root = createRoot(rootElement);
  root.render(<App />);
  anyRoot.__hasRoot = true;
}
